import React from "react";
import { useAuth } from "./auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await login();
      navigate("/profile");
    } catch (err) {
      console.error("Login failed", err);
    }
  };

  if (loading) {
    return <div style={{ display: "grid", placeItems: "center", minHeight: "70vh" }}>Checking your session…</div>;
  }

  if (user && !user.isAnonymous) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "70vh", padding: 16 }}>
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            border: "1px solid #dadce0",
            padding: "28px 32px",
            borderRadius: 12,
            boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
            fontFamily: "Arial, sans-serif",
            background: "#fff",
            textAlign: "center",
          }}
        >
          <h2 style={{ margin: "0 0 8px", fontWeight: 600 }}>You’re signed in</h2>
          <p style={{ margin: "0 0 20px", color: "#5f6368" }}>
            Continue to your profile or pick a game from the menu.
          </p>
          <button
            onClick={() => navigate("/profile")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              background: "#fff",
              border: "1px solid #dadce0",
              borderRadius: 6,
              padding: "10px 18px",
              cursor: "pointer",
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
              fontWeight: 600,
              color: "#3c4043",
            }}
          >
            Go to profile
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "70vh", padding: 16 }}>
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          border: "1px solid #dadce0",
          padding: "28px 32px",
          borderRadius: 12,
          boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
          fontFamily: "Arial, sans-serif",
          background: "#fff",
        }}
      >
        <h2 style={{ margin: "0 0 8px", fontWeight: 600 }}>Sign in to Dunderjeep Enterprises</h2>
        <p style={{ margin: "0 0 20px", color: "#5f6368" }}>Use Google to continue.</p>
        <button
          onClick={handleLogin}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            background: "#fff",
            border: "1px solid #dadce0",
            borderRadius: 6,
            padding: "10px 18px",
            cursor: "pointer",
            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            fontWeight: 600,
            color: "#3c4043",
          }}
        >
          <span
            aria-hidden
            style={{
              display: "inline-grid",
              placeItems: "center",
              width: 22,
              height: 22,
              borderRadius: "50%",
              fontWeight: 700,
              fontSize: 13,
              color: "#4285f4",
              background: "linear-gradient(135deg, #fff 0%, #eef3ff 100%)",
              border: "1px solid #d2e3fc",
            }}
          >
            G
          </span>
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
